import React from "react";
import Button from "../../../../../../../../components/button";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../../../../components/button/types";

interface SimpleModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

export const SimpleModal: React.FC<SimpleModalProps> = ({
  open,
  title,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white p-6 lg:rounded-lg shadow-lg lg:w-1/3 w-full h-full lg:h-auto">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <h2 className="text-sm font-semibold text-gray-900 mb-4">
          Coming soon..
        </h2>
        <div className="flex justify-end">
          <Button
            size={ButtonSize.SMALL}
            variant={ButtonVariant.SECONDARY}
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
